export default {
  colors: {
    background: {
      orange: '#F77403',
      white: '#FAFAFA',
      gray: '#F2F2F2',
    },

    orange: {
      dark: '#4D290A',
      pressing: '#D9731C',
      primary: '#F58220',
      light: '#F5C093',
    },

    blue: {
      pressing: '#004D8C',
      primary: '#005FAE',
      medium: '#3477AE',
      light: '#EDF7FF',
    },

    yellow: {
      pressing: '#D99837',
      primary: '#FBB040',
      light: '#FDD69B',
    },

    gray: {
      100: '#FAFAFA',
      200: '#F2F2F2',
      300: '#E5E4E5',
      400: '#CCCBCC',
      500: '#807E80',
      600: '#4D4C4D',
      900: '#1A191A',
    },

    white: '#fff',

    attention: '#CA1818',
    succesful: '#2EB033',
  },
  shadow: {
    default:
      '0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)',
  },
};
